import type { Prototype } from "../prototype-types";

export const yaoWangPrototypes: Prototype[] = [
  {
    id: "yao-legal-business-name-skip",
    name: "Legal Business Name – Make Skip Obvious",
    path: "/yao/legal-business-name-skip",
    description:
      "OBD-823. The signup legal business name step borrows the approved optional-website pattern: the primary button reads Skip while the field is empty and Next once the retailer types; everything else stays as production. Compare with production, a skip-link alternative and a reassurance-subheader option, across Opening Soon and established copy, mobile and desktop web, plus a clearer signup error state. Continue past the step into the rest of today’s signup flow: net terms or the Open with Faire upsell, then the “how did you hear about Faire” survey.",
    owner: "Yao Wang",
    createdAt: "2026-10-09",
    lastUpdated: "2026-10-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9b44d3308d944c7760a108362e48ccbb807219e7048ef7f6cbe8118462f4ab33.png",
    creationTool: "cursor",
  },
  {
    id: "yao-website-optional-v2",
    name: "Website Optional v2 – Capture Website Before First Order",
    path: "/yao/website-optional-v2",
    description:
      "Retailers who sell online — Opening Soon or established — keep website optional at signup, then add it in a checkout step before their first order, like the VAT step. Control vs treatment across signup, Business details, cart and checkout, desktop and mobile web.",
    owner: "Yao Wang",
    createdAt: "2026-09-14",
    lastUpdated: "2026-09-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/yao-website-optional-v2.png",
    creationTool: "cursor",
  },
  {
    id: "yao-website-optional-v2-checkout-flow",
    name: "Website Optional v2 – Checkout Steps Across Web and Apps",
    path: "/yao/website-optional-v2-checkout-flow",
    description:
      "Every step of a first order’s checkout on desktop web, mobile web, iOS and Android, built from today’s production screens plus the new website step: Carts, shipping address, VAT, website, payment and review. Click through one platform, line up all its steps today vs the proposal, or compare one step on all four. The website step’s Add and Skip buttons sit side by side, like VAT’s.",
    owner: "Yao Wang",
    createdAt: "2026-10-14",
    lastUpdated: "2026-10-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/c523c2c39d6b1ce32c17c8041ffd9fd611a1be5d33dededca3177e1ab7db98c5.png",
    creationTool: "cursor",
  },
  {
    id: "yao-fd-brand-aware-personal-info",
    name: "FD Signup – Brand-Aware Personal Info",
    path: "/yao/fd-brand-aware-personal-info",
    description:
      "After the Faire Direct modal, the personal-info screen borrows the branding FD product-page sign-ups already get: the brand’s products, “Try {Brand} in your store, risk-free”, the modal’s offer and the FD fine print, without asking for the email again. Compare production, that branding moved over as-is, and a lighter brand lockup without the product strip, on mobile and desktop web, for email and Google sign-ups. Annotations carry the Oct 8–21 drop-off data for each viewport.",
    owner: "Yao Wang",
    project: "Improve FD Signup",
    createdAt: "2026-10-26",
    lastUpdated: "2026-10-26",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/162e03018000635d784433543e76ca59e27ab4b7bc1cb8c47101cf5d0910464e.png",
    creationTool: "cursor",
  },
  {
    id: "yao-fd-pdp-email-first-signup",
    name: "FD Signup – Email-First on Product Pages",
    path: "/yao/fd-pdp-email-first-signup",
    description:
      "On Faire Direct product pages, sign-up opens a form that asks for email, name and password at once, with no Google option. Compare production with two fixes, on mobile and desktop web: every sign-up button opens the brand-page FD modal, with email or Google first, or today’s form gets “Sign up with Google” above the fields. The modal arm ends on the branded personal-info screen from FD Signup – Brand-Aware Personal Info, without the email field. Annotations carry the Oct 8–21 drop-off data for each viewport.",
    owner: "Yao Wang",
    project: "Improve FD Signup",
    createdAt: "2026-10-26",
    lastUpdated: "2026-10-28",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/7243c9f542f63338ceb76b7d10cf150ac8d3ee45d0087799886edcfcac1ba3a0.png",
    creationTool: "cursor",
  },
];
